document.addEventListener("turbolinks:load", function () {
    const guideSection = document.getElementById("electionByAcclamationSection");
    if (!guideSection) return; // Only run this on the Election by Acclamation page

    // Map aria-labels to their corresponding section IDs
    const linksToHeaders = {
      "Initial Requirements": "initial_requirements",
      "Hybrid/Electronic Voting Requirement": "electronic_consent_notice",
      "Nomination Forms": "nomination_forms",
      "Nomination Form Reminders": "nomination_form_reminders",
      "Results": "results"
    };

    Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const target = document.getElementById(targetId);

      if (link && target) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const headerOffset = 100; // Adjust for sticky header
          const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      }
    });
  });
